import { render, staticRenderFns } from "./TipoLicencia.vue?vue&type=template&id=6bfd783a&"
import script from "./TipoLicencia.vue?vue&type=script&lang=ts&"
export * from "./TipoLicencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6bfd783a', component.options)
    } else {
      api.reload('6bfd783a', component.options)
    }
    module.hot.accept("./TipoLicencia.vue?vue&type=template&id=6bfd783a&", function () {
      api.rerender('6bfd783a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/TipoLicencia.vue"
export default component.exports